// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../../../../../schema/public';

import { gql } from '@apollo/client';
import { TransactionNodeFragmentDoc } from '../../../../../../../../../shared/CashierNotifications/graphql/TransactionFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TransactionsQueryVariables = Types.Exact<{
  walletCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
  walletCurrencies?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['String']['input']>> | Types.InputMaybe<Types.Scalars['String']['input']>>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  fromDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  toDate?: Types.InputMaybe<Types.Scalars['String']['input']>;
  txActions?: Types.InputMaybe<Array<Types.InputMaybe<Types.TransactionActionTypes>> | Types.InputMaybe<Types.TransactionActionTypes>>;
}>;


export type TransactionsQuery = { __typename?: 'Query', banking?: { __typename: 'Banking', id: string, myTransactions?: { __typename: 'BankingTransactionConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string, endCursor?: string }, edges?: Array<{ __typename: 'BankingTransactionEdge', cursor: string, node?: { __typename: 'BankingTransaction', id: string, rawId?: string, txType?: Types.BankingTransactionType, amount?: number, currency?: string, endingBalance?: number, status?: Types.BankingTransactionStatus, createTime?: number, description?: string, confirmations?: number, txId?: string, address?: string, provider?: string, txAction?: Types.TransactionActionTypes, providerMethod?: string } }> } } };


export const TransactionsQueryDocument = /*#__PURE__*/ gql`
    query TransactionsQuery($walletCurrency: String, $walletCurrencies: [String], $first: Int, $after: String, $fromDate: String, $toDate: String, $txActions: [TransactionActionTypes]) {
  banking {
    id
    myTransactions(
      walletCurrency: $walletCurrency
      walletCurrencies: $walletCurrencies
      txActions: $txActions
      first: $first
      after: $after
      fromDate: $fromDate
      toDate: $toDate
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
        __typename
      }
      edges {
        cursor
        node {
          ...TransactionNode
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    ${TransactionNodeFragmentDoc}`;
export function useTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsQueryDocument, options);
      }
export function useTransactionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsQueryDocument, options);
        }
export function useTransactionsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsQueryDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsQueryLazyQueryHookResult = ReturnType<typeof useTransactionsQueryLazyQuery>;
export type TransactionsQuerySuspenseQueryHookResult = ReturnType<typeof useTransactionsQuerySuspenseQuery>;
export type TransactionsQueryQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;